"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EtudeError extends Error {
    constructor(message) {
        super(message);
    }
    static forNull(c) {
        return new EtudeError(`[${c.name}] Null value`);
    }
    static forIllegalState(c, reason) {
        return new EtudeError(`[${c.name}] Illegal state: ${reason}`);
    }
    static forIllegalArgument(c, t, reason) {
        return new EtudeError(`[${c.name}] Illegal argument: ${t} (${reason})`);
    }
    static forInvalid(c, t, reason) {
        return new EtudeError(`[${c.name}] Invalid value: ${t}` + (reason == null ? "" : `(${reason})`));
    }
}
exports.default = EtudeError;
